/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import { jsx } from '@atlaskit/css';
import AddIcon from '@atlaskit/icon/core/add';

import messages from './messages';

// Reference: packages/editor/editor-ai-injected-editors/src/components/LinkPickerButton/LinkPickerButton.tsx
export const AddItemButton = () => {
	const { formatMessage } = useIntl();
	// TODO: EDITOR-764 - Work to implement in this ticket
	return (
		<IconButton
			isDisabled={true}
			isTooltipDisabled={false}
			label={formatMessage(messages.label)}
			testId="editor-ai-add-item-button"
			icon={AddIcon}
			spacing="compact"
			appearance="subtle"
			onClick={() => {}}
			onKeyDown={() => {}}
			onKeyUp={() => {}}
		/>
	);
};
